/* eslint-disable react/prop-types */
import {
  Document,
  Font,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import React from "react";
import Roboto_BOLD from "../../../assets/fonts/Roboto-Bold.ttf";
import Roboto_ITALIC from "../../../assets/fonts/Roboto-Italic.ttf";
import Roboto_NORMAL from "../../../assets/fonts/Roboto-Regular.ttf";
import { formatNumber } from "../../../redux/utils";
import { toWordsconver } from "../../../redux/api";

Font.register({
  family: "Roboto",
  fonts: [
    { src: Roboto_NORMAL, fontWeight: 700 },
    {
      src: Roboto_BOLD,
      fontStyle: "bold",
    },
    {
      src: Roboto_ITALIC,
      fontStyle: "italic",
    },
  ],
});

const styles = StyleSheet.create({
  body: {
    width: "100%",
    pageBreakInside: "avoid",
    paddingLeft: 20,
    paddingRight: 20,
    fontSize: 10,
    flexDirection: "row",
    lineHeight: 1.5,
  },
  leftBody: {
    width: "75%",
    height: "76vh",
    paddingTop: 10,
    borderRight: "2px solid #000",
  },
  rightBody: {
    width: "30%",
    paddingLeft: 20,
    paddingTop: 10,
  },
  table: {
    borderTop: 1,
    borderBottom: 1,
    width: "100%",
    flexDirection: "row",
  },
  image: {
    width: 30,
    height: 30,
  },
  image1: {
    width: 110,
    height: 100,
    marginLeft: -15,
    marginTop: 50,
  },
});

export const PaymentVoucherPdf = ({ form, taxesApplied, mda }) => {
  // const mda = useSelector((state) => state.auth.user);
  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const totalTaxesAmount = taxesApplied?.reduce((total, tax) => {
    return total + (Number(tax.cr) || 0);
  }, 0);

  const netAmount =
    Number(form[0]?.amount || form[0]?.approved_amount) - totalTaxesAmount;

  return (
    <Document>
      <Page size="A3">
        <View
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
       
          <View
            style={{
              width: "100%",
              alignItems: "center",
            }}
          >
            <Image
              src={require("../../../assets/img/KTSG.png")}
              style={styles.image1}
            />
            <Text
              style={{
                fontSize: 17,
                marginTop: 10,
                fontFamily: "DM_SANS",
                fontStyle: "bold",
              }}
            >
              TREASURY BUDGET AND EXPENDITURE ASSURANCE SYSTEM
            </Text>
            <Text
              style={{
                fontSize: 20,
                fontFamily: "DM_SANS",
                fontStyle: "bold",
              }}
            >
              MINISTRY OF FINANCE
            </Text>
            <Text
              style={{
                fontSize: 17,
                fontFamily: "DM_SANS",
                fontStyle: "bold",
              }}
            >
              MINISTERIAL/DEPARTMENTAL PAYMENT VOUCHER
            </Text>
          </View>
          <View style={styles.body}>
            <View style={styles.leftBody}>
              <Text
                style={{
                  fontFamily: "Roboto",
                  fontStyle: "bold",
                  fontSize: 18,
                  width: "100%",
                  marginLeft: 317,
                }}
              >
                PAYMENT VOUCHER
              </Text>
              <Text
                style={{
                  fontFamily: "Roboto",
                  fontStyle: "bold",
                }}
              >
                KTT.44
              </Text>
              <Text>
                Organisation: {form[0]?.mda_name ? form[0]?.mda_name : ""}
                {/* } */}
              </Text>
              <Text>Sub Organisation Name: {form[0]?.mda_head ? form[0]?.mda_head : ""}</Text>
              <Text
                style={{
                  marginBottom: 2,
                }}
              >
                Payment to:{" "}
                {form[0]?.contractor_name ? form[0]?.contractor_name : ""}
              </Text>
              <View style={styles.table}>
                <Text
                  style={{
                    fontFamily: "Roboto",
                    fontStyle: "bold",
                    width: "10%",
                    borderRight: 1,
                    textAlign: "right",
                  }}
                >
                  Date
                </Text>
                <Text
                  style={{
                    fontFamily: "Roboto",
                    fontStyle: "bold",
                    width: "50%",
                    borderRight: 1,
                    textAlign: "center",
                  }}
                >
                  Detailed description of service
                </Text>
                <Text
                  style={{
                    fontFamily: "Roboto",
                    fontStyle: "bold",
                    width: "10%",
                    borderRight: 1,
                    textAlign: "center",
                  }}
                >
                  Rate
                </Text>
                <View
                  style={{
                    width: "30%",
                    flexDirection: "column",
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "Roboto",
                      fontStyle: "bold",
                      width: "100%",
                      borderRight: 1,
                      textAlign: "center",
                    }}
                  >
                    Amount
                  </Text>
                  <View
                    style={{
                      width: "100%",
                      flexDirection: "row",
                      borderTop: 1,
                    }}
                  >
                    <Text
                      style={{
                        width: "80%",
                        borderRight: 1,
                        paddingLeft: 10,
                      }}
                    >
                      N
                    </Text>
                    <Text
                      style={{
                        width: "20%",
                        borderRight: 1,
                        paddingLeft: 4,
                      }}
                    >
                      K
                    </Text>
                  </View>
                </View>
              </View>
              <View
                style={
                  form
                    ? {
                        borderBottom: 1,
                        width: "100%",
                        flexDirection: "row",
                      }
                    : {
                        height: 320,
                      }
                }
              >
                <View
                  style={{
                    fontFamily: "Roboto",
                    fontStyle: "bold",
                    width: "10%",
                    borderRight: 1,
                    textAlign: "right",
                  }}
                >
                  {/* {form?.approval_date} */}
                </View>
                <View
                  style={{
                    fontFamily: "Roboto",
                    width: "50%",
                    height: 130,
                    borderRight: 1,
                    textAlign: "left",
                    paddingLeft: 5,
                  }}
                >
                  <Text>{capitalizeFirstLetter(form[0]?.narration)}</Text>
                  <View style={{ flexDirection: "row", width: "100%" }}>
                    <View
                      style={{
                        flexDirection: "column",
                        width: "50%",
                        marginTop: 30,
                      }}
                    >
                      {taxesApplied.map((tax, idx) => (
                        <Text key={idx}>{tax.deduction_description}</Text>
                      ))}
                      <Text>Total Deduction</Text>
                    </View>
                    <View
                      style={{
                        flexDirection: "column",
                        width: "30%",
                        marginTop: 30,
                      }}
                    >
                      {taxesApplied.map((tax, idx) => (
                        <Text style={{ textAlign: "right" }} key={idx}>
                          {formatNumber(tax.cr)}
                        </Text>
                      ))}
                      <View style={{ borderWidth: 1 }}></View>
                      <Text style={{ textAlign: "right" }}>
                        {formatNumber(totalTaxesAmount)}
                      </Text>
                    </View>
                  </View>
                </View>
                <View
                  style={{
                    fontFamily: "Roboto",
                    fontStyle: "bold",
                    width: "10%",
                    borderRight: 1,
                    textAlign: "center",
                  }}
                ></View>
                <View
                  style={{
                    fontFamily: "Roboto",
                    fontStyle: "bold",
                    width: "30%",
                    borderRight: 1,
                    textAlign: "center",
                    flexDirection: "row",
                  }}
                >
                  <View
                    style={{
                      width: "83%",
                      borderRight: 1,
                      paddingLeft: 10,
                      textAlign: "right",
                    }}
                  >
                    <Text>
                      {/* N300,000 */}
                      {
                        formatNumber(
                          form[0]?.amount
                            ? form[0]?.amount
                            : form[0]?.approved_amount
                        )?.split(".")
                      }
                    </Text>
                  </View>
                  <View
                    style={{
                      width: "20%",
                      paddingLeft: 10,
                    }}
                  >
                    <Text>
                      {form[0]?.amount?.toString()?.split(".")[1] || "00"}
                    </Text>
                  </View>
                </View>
              </View>
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  borderBottom: 1,
                }}
              >
                <View
                  style={{
                    flexDirection: "column",
                    width: "60%",
                    height: 50,
                    borderRight: 1,
                    paddingLeft: 5,
                    paddingRight: 5,
                  }}
                >
                  <Text
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      // textTransform: "lowercase"
                    }}
                  >
                    Total amount in words:{" "}
                  </Text>
                  {/* <br /> */}
                  <Text
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      textTransform: "lowercase",
                    }}
                  >
                    {toWordsconver(
                      netAmount.toString().split(".")
                    )?.toLowerCase()}
                    NAIRA
                    {netAmount.toString().split(".")[1] &&
                    netAmount.toString().split(".")[1] !== "00"
                      ? ` AND ${toWordsconver(
                          netAmount.toString().split(".")[1]
                        )?.toLowerCase()} KOBO`
                      : null}{" "}
                    ONLY
                  </Text>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "40%",
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "Roboto",
                      fontStyle: "bold",
                      marginLeft: 100,
                      marginTop: 5,
                    }}
                  >
                    TOTAL: {formatNumber(netAmount)}
                  </Text>
                </View>
              </View>
              <View
                style={{
                  width: "100%",
                  borderBottom: 1,
                  paddingLeft: 2,
                  flexDirection: "column",
                }}
              >
                <Text style={{ width: "100%", textAlign: "justify", fontSize: 10.5, paddingTop: 3 }}>
                  Certified that the details above are in accordance with the
                  relevant contract, regulations or other authorty under which
                  goods/services where providec purchased.
                </Text>
                <Text
                  style={{
                    width: "100%",
                    textAlign: "justify",
                  }}
                >
                  Officer who prepared the voucher: Signate ....................................................................................................................................
                </Text>
                <View
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    marginBottom: 20,
                  }}
                >
                  <Text
                    style={{
                      width: "50%",
                      textTransform: "uppercase",
                    }}
                  >
                    Name (in block letters): {/* {mda?.fullname} */}
                  </Text>
                  <Text
                    style={{
                      width: "50%",
                    }}
                  >
                    Date: {form[0]?.collection_date}
                  </Text>
                </View>

                <View
                  style={{
                    width: "100%",
                    flexDirection: "column",
                  }}
                >
                  <Text
                    style={{
                      width: "100%",
                    }}
                  >
                    Officer who checked the voucher: Signature ....................................................................................................................................
                  </Text>
                </View>
                <View
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    marginBottom: 20,
                  }}
                >
                  <Text
                    style={{
                      width: "50%",
                      textTransform: "uppercase",
                    }}
                  >
                    Name (in block letters):
                    {/* {reviewedSignature?.fullname} */}
                  </Text>
                  <Text
                    style={{
                      width: "50%",
                    }}
                  >
                    Date: {form[0]?.collection_date}
                  </Text>
                </View>
              </View>
              <View
                style={{
                  width: "100%",
                  borderBottom: 1,
                  paddingLeft: 2,
                  flexDirection: "column",
                }}
              >
                <Text style={{ width: "100%", textAlign: "justify", fontSize: 10, paddingTop: 3 }}>
                  I certify that the services/goods have been duly performed/redeved and that financial authority............................................................................................................................................................
                  is held to incur this expenditure and that relavant D.V.E account entries have been made.
                </Text>
                <Text
                  style={{
                    width: "100%",
                    textAlign: "justify",
                  }}
                >
                  Signate ..............................................................................................................................................................................................
                </Text>
                <View
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    marginBottom: 20,
                  }}
                >
                  <Text
                    style={{
                      width: "50%",
                      textTransform: "uppercase",
                    }}
                  >
                    (Officer controling vole or A I.E): {/* {mda?.fullname} */}
                  </Text>
                </View>
                <View
                  style={{
                    width: "100%",
                    flexDirection: "row",
                  }}
                >
                  <Text
                    style={{
                      width: "70%",
                    }}
                  >
                    Name (in block letters):.......................................................................................................
                  </Text>
                  <Text
                    style={{
                      width: "30%",
                    }}
                  >
                    Date: {form[0]?.collection_date}
                  </Text>
                </View>
              </View>
              <View
                style={{
                  width: "100%",
                  borderBottom: 1,
                  paddingLeft: 2,
                  flexDirection: "row",
                }}
              >
                <Text
                  style={{
                    width: "50%",
                  }}
                >
                  Cheque No: {form[0]?.cheque_no}
                </Text>
                <Text
                  style={{
                    width: "50%",
                  }}
                >
                  Account No: {form[0]?.payment_acc_no}
                </Text>
              </View>
              <View
                style={{
                  width: "100%",
                  borderBottom: 1,
                  paddingLeft: 2,
                  flexDirection: "row",
                }}
              >
                <Text
                  style={{
                    width: "50%",
                  }}
                >
                  Account Name: {form[0]?.payment_account_name}
                </Text>
                <Text
                  style={{
                    width: "50%",
                  }}
                >
                  {" "}
                  Name of Bank: {form[0]?.payment_bank_name}
                </Text>
              </View>
              <View
                style={{
                  width: "100%",
                  paddingLeft: 2,
                  flexDirection: "column",
                }}
              >
                <Text
                  style={{
                    width: "100%",
                  }}
                >
                  Received the sum of .....................................
                  Naira and......................................Kobo in
                </Text>
                <Text
                  style={{
                    width: "100%",
                  }}
                >
                  acquisition of the above Account
                  this.............................Day
                  of..........................20..........
                </Text>
                <Text
                  style={{
                    width: "100%",
                  }}
                >
                  Amount in word.....................................Name of
                  Payee...................................................
                </Text>
                <Text
                  style={{
                    width: "100%",
                  }}
                >
                  Witness in official
                  Name..........................................Rank.................................................
                </Text>
                <View
                  style={{
                    flexDirection: "row",
                    width: "60%",
                    marginLeft: 40,
                  }}
                >
                  <View
                    style={{
                      flexDirection: "column",
                    }}
                  >
                    <Text>Witness</Text>
                    <Text>Official</Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "column",
                      marginLeft: 40,
                    }}
                  >
                    <Text>Name.......................................</Text>
                    <Text>Rank........................................</Text>
                  </View>
                </View>
              </View>
            </View>
            <View style={styles.rightBody}>
              <View
                style={{
                  width: "100%",
                }}
              >
                <Text
                  style={{
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  Voucher Number
                </Text>
                <View
                  style={{
                    width: "100%",
                    border: 1,
                    flexDirection: "row",
                  }}
                >
                  {String(form[0]?.pv_code)
                    .split("")
                    .map((digit, index) => (
                      <Text
                        key={index}
                        style={{
                          width: "100%",
                          textAlign: "center",
                          borderRight:
                            index < String(form[0]?.pv_code).length - 1 ? 1 : 0,
                          paddingTop: 3,
                        }}
                      >
                        {digit}
                      </Text>
                    ))}
                </View>
              </View>
              <View
                style={{
                  width: "100%",
                  marginTop: 30,
                }}
              >
                <Text
                  style={{
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  Date/Month/Year
                </Text>
                <View
                  style={{
                    width: "100%",
                    border: 1,
                    flexDirection: "row",
                  }}
                >
                  {String(form[0]?.collection_date)
                    .split("")
                    .map((digit, index) => (
                      <Text
                        key={index}
                        style={{
                          width: "12.5%",
                          textAlign: "center",
                          borderRight:
                            index < String(form[0]?.date).length - 1 ? 1 : 0,
                          paddingTop: 3,
                        }}
                      >
                        {digit}
                      </Text>
                    ))}
                </View>
              </View>
              <View
                style={{
                  width: "100%",
                  marginTop: 30,
                }}
              >
                <Text
                  style={{
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  Administrative Code
                </Text>
                <View
                  style={{
                    width: "100%",
                    border: 1,
                    flexDirection: "row",
                  }}
                >
                  {String(form[0]?.mda_code)
                    .split("")
                    .map((digit, index) => (
                      <Text
                        key={index}
                        style={{
                          width: "8.3%",
                          textAlign: "center",
                          borderRight:
                            index < String(form[0]?.mda_code).length - 1
                              ? 1
                              : 0,
                          paddingTop: 3,
                        }}
                      >
                        {digit}
                      </Text>
                    ))}
                </View>
              </View>
              <View
                style={{
                  width: "100%",
                  marginTop: 30,
                }}
              >
                <Text
                  style={{
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  Economic Code
                </Text>
                <View
                  style={{
                    width: "100%",
                    border: 1,
                    flexDirection: "row",
                    height: 21,
                  }}
                >
                  {String(
                    form[0]?.economic_code
                      ? form[0]?.economic_code
                      : form[0]?.mda_economic_code
                  )
                    .split("")
                    .map((digit, index) => (
                      <Text
                        key={index}
                        style={{
                          width: "12.5%",
                          textAlign: "center",
                          borderRight:
                            index <
                            String(
                              form[0]?.economic_code
                                ? form[0]?.economic_code
                                : form[0]?.mda_economic_code
                            ).length -
                              1
                              ? 1
                              : 0,
                          paddingTop: 3,
                        }}
                      >
                        {digit}
                      </Text>
                    ))}
                </View>
              </View>
              <View
                style={{
                  width: "100%",
                  marginTop: 30,
                }}
              >
                <Text
                  style={{
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  Program Code
                </Text>
                <View
                  style={{
                    width: "100%",
                    border: 1,
                    flexDirection: "row",
                  }}
                >
                  {String(
                    form[0]?.program_code
                      ? form[0]?.program_code
                      : form[0]?.program_code
                  )
                    .split("")
                    .map((digit, index) => (
                      <Text
                        key={index}
                        style={{
                          width: "100%",
                          textAlign: "center",
                          borderRight:
                            index <
                            String(
                              form[0]?.program_code
                                ? form[0]?.program_code
                                : form[0]?.program_code
                            ).length -
                              1
                              ? 1
                              : 0,
                          paddingTop: 3,
                        }}
                      >
                        {digit}
                      </Text>
                    ))}
                </View>
              </View>
              <View
                style={{
                  width: "100%",
                  marginTop: 30,
                }}
              >
                <Text
                  style={{
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  Functional Code
                </Text>
                <View
                  style={{
                    width: "100%",
                    border: 1,
                    flexDirection: "row",
                  }}
                >
                  {String(
                    form[0]?.functional_code
                      ? form[0]?.functional_code
                      : form[0]?.function_code
                  )
                    .split("")
                    .map((digit, index) => (
                      <Text
                        key={index}
                        style={{
                          width: "100%",
                          textAlign: "center",
                          borderRight:
                            index <
                            String(
                              form[0]?.functional_code
                                ? form[0]?.functional_code
                                : form[0]?.function_code
                            ).length -
                              1
                              ? 1
                              : 0,
                          paddingTop: 3,
                        }}
                      >
                        {digit}
                      </Text>
                    ))}
                </View>
              </View>
              <View
                style={{
                  width: "100%",
                  marginTop: 30,
                }}
              >
                <Text
                  style={{
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  Fund Code
                </Text>
                <View
                  style={{
                    width: "100%",
                    border: 1,
                    flexDirection: "row",
                  }}
                >
                  {String(form[0]?.fund_code)
                    .split("")
                    .map((digit, index) => (
                      <Text
                        key={index}
                        style={{
                          width: "100%",
                          textAlign: "center",
                          borderRight:
                            index < String(form[0]?.fund_code).length - 1
                              ? 1
                              : 0,
                          paddingTop: 3,
                        }}
                      >
                        {digit}
                      </Text>
                    ))}
                </View>
              </View>
              <View
                style={{
                  width: "100%",
                  marginTop: 30,
                }}
              >
                <Text
                  style={{
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  Geo Code
                </Text>
                <View
                  style={{
                    width: "100%",
                    border: 1,
                    flexDirection: "row",
                  }}
                >
                  {String(form[0]?.geo_code)
                    .split("")
                    .map((digit, index) => (
                      <Text
                        key={index}
                        style={{
                          width: "100%",
                          textAlign: "center",
                          borderRight:
                            index < String(form[0]?.geo_code).length - 1
                              ? 1
                              : 0,
                          paddingTop: 3,
                        }}
                      >
                        {digit}
                      </Text>
                    ))}
                </View>
              </View>
              <View
                style={{
                  width: "100%",
                  marginTop: 50,
                }}
              >
                <Text>Date received in Treasury </Text>
                <Text>............................................</Text>
                <Text
                  style={{
                    marginBottom: 15,
                  }}
                >
                  Check and passed at{" "}
                </Text>
                <Text>............................................</Text>
                <Text
                  style={{
                    marginBottom: 15,
                  }}
                >
                  For{" "}
                </Text>
                <Text
                  style={{
                    marginBottom: 15,
                  }}
                >
                  Payable only at{" "}
                </Text>
                <Text>Checked by internal Auditor</Text>
                <Text>(Name and Signature)</Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};